<div ref:chapterIndex class="chapter-index chapter-index__{{$index_chapter}} chapter-index__{{$index_active ? 'visible' : 'hidden'}}">
        <div class="intro-panel">
            <div class="intro-panel__inner">
                <button class="intro-panel__btn" on:click="openIntro()"><span class="intro-panel__btn-text">Introduction</span></button>
            </div>
        </div>
    {{#each $chapter_index as chapter, n }}
        <div class="chapter-panel chapter-panel__{{chapter.chapter}} {{ $index_chapter == chapter.chapter ? 'active' : 'inactive' }}" on:click="highlightChapter(chapter.chapter)">
            <div class="chapter-title">
                <span class="chapter-title__overline">{{ chapter.title }}</span>
                <span class="chapter-title__main">{{ chapter.chapter }}</span>
            </div>

            <div class="chapter-panel__progress">
                {{#if $current_chapter == $index_chapter && $index_chapter == chapter.chapter && $current_slide > 0}}
                <Progress total={{$slides.length}}/>
                {{/if}}
            </div>

            <div class="chapter-content chapter-content__{{ $index_chapter == chapter.chapter ? 'active' : 'inactive' }} chapter-content__{{ $index_chapter == chapter.chapter ? 'display' : 'hide' }}">
                

                <div class="chapter-text">
                    <div class="chapter-blurb">{{chapter.intro}}</div>
                    <button class="chapter-button" on:click="openChapter()">{{ buttonText }}</button>
                </div>
            </div>

            <div class="media-outer">
                {{#if $isMobile.any || ($bowser && $bowser.safari)}}
                <img src="{{ chapter.bg_img2 }}" alt="" />
                {{else}}
                <video muted loop playsinline class="chapter-video chapter-video-{{ $index_chapter == chapter.chapter ? 'playing' : 'paused' }}">
                    <source src="{{ video(chapter.webm) }}" type="video/webm">
                    <source src="{{ video(chapter.mp4) }}" type="video/mp4">
                </video>
                {{/if}}
            </div>

            <img alt="chapter silos" class="chapter-silos" src="{{ chapter.bg_img }}" />

        </div>
    {{/each}}
</div>

<script>
import Progress from './Progress.html'
import { video, triggerIndexVideo, noop } from './helpers'

export default {
    components: {
        Progress,
    },

    computed: {

        buttonText: ($current_slide, $current_chapter, $index_chapter) => {
            if( $current_chapter == $index_chapter && $current_slide > 0 ) {
                return 'Continue';
            }
            return 'Begin';
        },

    },

    oncreate() {
        this.clicked = false;
    },

    methods: {

        highlightChapter(chapter) {
            if (this.clicked || chapter == this.store.get('index_chapter')) return;
            this.clicked = true;
            
            setTimeout(() => { 
                this.clicked = false;
            }, 1000); 
            
            this.store.set({ index_chapter: chapter });  

            if ( !store.get('isMobile').any ) triggerIndexVideo();

        },

        openChapter() {
            if ( this.store.get('current_chapter') == this.store.get('index_chapter') ){
                store.set({ 
                    index_active: false 
                });
            } else {
                store.set({ 
                    current_chapter: this.store.get('index_chapter'), 
                    current_slide: 0, 
                    index_active: false 
                });   
            }
        },

        openIntro() {
            this.store.set({ current_chapter: 'intro', current_slide: 0, index_active: false });
        }

    },

    helpers: {
        video,
    }

}
</script>
